import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const segmentsSectionHeaderSx: SxProps<Theme> = {
  gridColumn: '1 / -1',
};

export const segmentsContainerSx: SxProps<Theme> = {
  gridColumn: '1 / -1',
  display: 'flex',
  flexWrap: 'wrap',
  m: '0 8px',
};

export const segmentRootSx: SxProps<Theme> = {
  display: 'flex',
  minWidth: '216px',
  maxWidth: '280px',
  flexWrap: 'wrap',
  '& .inputsRow': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    px: 2,
  },
};

export const segmentIconSx: SxProps<Theme> = {
  width: '18px',
  height: '18px',
  mr: 2,
  flexShrink: 0,
};

export const segmentTextFieldSx: SxProps<Theme> = {
  height: '48px',
  maxWidth: '90px',
  fill: Color.iconGray,
  '& input': {
    height: '48px',
    boxSizing: 'border-box',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: Color.neutralBorderGray,
  },
  '& .MuiInputLabel-outlined:not(.MuiInputLabel-shrink)': {
    transform: 'translate(14px, 16px) scale(1)',
  },
};

export const segmentHyphenSx: SxProps<Theme> = {
  borderTop: `1px solid ${Color.neutralBorderGray}`,
  width: '11px',
  flexShrink: 0,
  m: '0 6px',
};

export const segmentHelperTextSx: SxProps<Theme> = {
  m: '4px 0 16px 0',
  minHeight: '1.66em',
  width: '100%',
  px: '0 16px 0 50px',
};
